var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.5417H10.625L10 14.1667L9.375 13.5417M13.3333 11.6667V12.0834",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68338 9.3725C3.45058 10.2732 3.33297 11.1997 3.33338 12.13C3.33338 15.6067 6.31837 17.5 10 17.5C13.6817 17.5 16.6667 15.6067 16.6667 12.13C16.6626 11.1959 16.5242 10.2672 16.2559 9.3725M6.66671 11.6667V12.0833",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08332 7.08333C6.76332 7.95833 6.18082 8.77333 5.12998 9.16666C3.52082 9.76833 2.14998 8.91916 2.08332 8.33333C1.98915 7.50499 3.06415 2.89166 5.41665 2.49999C7.01915 2.23249 8.45915 3.20416 8.45915 4.36249C9.51316 4.09493 10.6187 4.10699 11.6667 4.39749C11.6667 3.23916 13.2033 2.23249 14.8058 2.49999C17.1583 2.89166 18.2333 7.50499 18.1392 8.33333C18.0725 8.91916 16.7017 9.76833 15.0925 9.16666C14.0417 8.77333 13.5467 7.95833 13.2267 7.08333",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPet);
export default __webpack_public_path__ + "static/media/pet.e230314ea1f1aa4128d17e3b348bc55f.svg";
export { ForwardRef as ReactComponent };